import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=be3e0a58&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=ts&"
export * from "./SearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=be3e0a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3e0a58",
  null
  
)

export default component.exports